import { render } from "./HackathonResult.vue?vue&type=template&id=64e017b4&scoped=true"
import script from "./HackathonResult.vue?vue&type=script&lang=js"
export * from "./HackathonResult.vue?vue&type=script&lang=js"

import "./HackathonResult.vue?vue&type=style&index=0&id=64e017b4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64e017b4"

export default script